'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SuccessAlertIcon = function SuccessAlertIcon(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement('path', { fill: fill, fillRule: 'evenodd', d: 'M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm-1-2.586L12.414 6 11 4.586l-4 4-2-2L3.586 8 7 11.414z' })
    )
  );
};

SuccessAlertIcon.propTypes = _extends({}, _Icon2.default.propTypes);

SuccessAlertIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  size: 'small',
  fill: _theme2.default.colors.success
});

exports.default = SuccessAlertIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1N1Y2Nlc3NBbGVydEljb24uanMiXSwibmFtZXMiOlsiU3VjY2Vzc0FsZXJ0SWNvbiIsImZpbGwiLCJwcm9wcyIsImRpc3BsYXkiLCJwcm9wVHlwZXMiLCJkZWZhdWx0UHJvcHMiLCJzaXplIiwiY29sb3JzIiwic3VjY2VzcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsbUJBQW1CLFNBQW5CQSxnQkFBbUIsT0FBd0I7QUFBQSxNQUFyQkMsSUFBcUIsUUFBckJBLElBQXFCO0FBQUEsTUFBWkMsS0FBWTs7QUFDL0MsU0FDRTtBQUFBO0FBQVVBLFNBQVY7QUFDRTtBQUFBO0FBQUEsUUFBSyxPQUFPLEVBQUVDLFNBQVMsT0FBWCxFQUFaLEVBQWtDLE9BQU0sTUFBeEMsRUFBK0MsUUFBTyxNQUF0RCxFQUE2RCxTQUFRLFdBQXJFO0FBQ0UsOENBQU0sTUFBTUYsSUFBWixFQUFrQixVQUFTLFNBQTNCLEVBQXFDLEdBQUUsb0xBQXZDO0FBREY7QUFERixHQURGO0FBT0QsQ0FSRDs7QUFVQUQsaUJBQWlCSSxTQUFqQixnQkFDSyxlQUFLQSxTQURWOztBQUlBSixpQkFBaUJLLFlBQWpCLGdCQUNLLGVBQUtBLFlBRFY7QUFFRUMsUUFBTSxPQUZSO0FBR0VMLFFBQU0sZ0JBQU1NLE1BQU4sQ0FBYUM7QUFIckI7O2tCQU1lUixnQiIsImZpbGUiOiJTdWNjZXNzQWxlcnRJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJ1xuaW1wb3J0IHRoZW1lIGZyb20gJy4vdGhlbWUnXG5cbmNvbnN0IFN1Y2Nlc3NBbGVydEljb24gPSAoeyBmaWxsLCAuLi5wcm9wcyB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPEljb24gey4uLnByb3BzfT5cbiAgICAgIDxzdmcgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyB2aWV3Qm94PScwIDAgMTYgMTYnPlxuICAgICAgICA8cGF0aCBmaWxsPXtmaWxsfSBmaWxsUnVsZT0nZXZlbm9kZCcgZD0nTTggMEMzLjU4OSAwIDAgMy41ODkgMCA4czMuNTg5IDggOCA4IDgtMy41ODkgOC04LTMuNTg5LTgtOC04em0wIDE0Yy0zLjMwOSAwLTYtMi42OTEtNi02czIuNjkxLTYgNi02IDYgMi42OTEgNiA2LTIuNjkxIDYtNiA2em0tMS0yLjU4NkwxMi40MTQgNiAxMSA0LjU4NmwtNCA0LTItMkwzLjU4NiA4IDcgMTEuNDE0eicgLz5cbiAgICAgIDwvc3ZnPlxuICAgIDwvSWNvbj5cbiAgKVxufVxuXG5TdWNjZXNzQWxlcnRJY29uLnByb3BUeXBlcyA9IHtcbiAgLi4uSWNvbi5wcm9wVHlwZXNcbn1cblxuU3VjY2Vzc0FsZXJ0SWNvbi5kZWZhdWx0UHJvcHMgPSB7XG4gIC4uLkljb24uZGVmYXVsdFByb3BzLFxuICBzaXplOiAnc21hbGwnLFxuICBmaWxsOiB0aGVtZS5jb2xvcnMuc3VjY2Vzc1xufVxuXG5leHBvcnQgZGVmYXVsdCBTdWNjZXNzQWxlcnRJY29uXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/SuccessAlertIcon.js
// module id = 589
// module chunks = 0